import NewTeam from "features/teams/NewTeam"

const NewTeamPage = () => {
    return (
        <NewTeam />
    )
}

export default NewTeamPage